import { Pipe, PipeTransform } from '@angular/core';
import { DosingObject, DosingPeriodObject } from '@it2go/types';
import { translate } from '../../../../shared/shared.global-service';
import {
    ServiceTimeRangeObject,
} from '@libs/types/src/services/object-type/service/settings/service-time-range.object';

@Pipe({
    name: 'formatDosing',
})

export class FormatDosingPipe implements PipeTransform {

    public transform(dosingPeriod: DosingPeriodObject, dosing: DosingObject, ranges?: ServiceTimeRangeObject[]): any {
        return formatDosing(dosingPeriod, dosing, ranges);
    }

}

export function formatDosing(
    dosingPeriod: DosingPeriodObject,
    dosing: DosingObject,
    ranges?: ServiceTimeRangeObject[],
): string {
    let formatted = '';
    const { custom, days, hours } = dosingPeriod;

    const actives = {} as Record<number, boolean>;
    ranges?.forEach((it) => {
        actives[it.order] = it.active;
    });

    if (custom && custom !== '') {
        return dosingPeriod.custom;
    }

    if (days) {
        let dosings = [
            (actives[0] ?? true) ? dosing.morning : null,
            (actives[1] ?? true) ? dosing.forenoon : null,
            (actives[2] ?? true) ? dosing.noon : null,
            (actives[3] ?? true) ? dosing.afternoon : null,
            (actives[4] ?? true) ? dosing.evening : null,
            (actives[5] ?? true) ? dosing.night : null,
        ];

        formatted += dosings
            .filter((it) => it !== null)
            .join('-')
        ;
        formatted += days === 1 ? translate.instant('folderMedication.daily') :
            translate.instant('folderMedication.eachNDay1')
            + days + translate.instant('folderMedication.eachNDay2');
    } else if (hours) {
        formatted += dosing.hours.join('-')
            + translate.instant('folderMedication.eachNHour1')
            + hours + translate.instant('folderMedication.eachNHour2');
    }

    return formatted;
}
